export const mobileSessionMediaQuery = '(max-width: 760px), (pointer: coarse) and (max-width: 1100px)';
export const mobileSessionAwayLimitMs = 60_000;
export const mobilePasskeyOrigin = 'https://safety.kop.co.kr';

export function mobilePasskeyAvailable(adapterAvailable: boolean, origin = window.location.origin) {
  return adapterAvailable && origin === mobilePasskeyOrigin && typeof PublicKeyCredential !== 'undefined';
}

export function mobilePasskeyEnvelope(value: unknown) {
  if (!value || typeof value !== 'object' || Array.isArray(value))
    throw new Error('PASSKEY_RESPONSE_INVALID');
  return value as Record<string, unknown>;
}

export function mustLockAfterAbsence(hiddenAt: number | null, now: number) {
  return hiddenAt !== null && (now < hiddenAt || now - hiddenAt >= mobileSessionAwayLimitMs);
}

export function mobileUnlockError(error: unknown) {
  const raw = error && typeof error === 'object' && 'details' in error
    ? (error as { details?: { code?: unknown } }).details?.code
    : undefined;
  const code = typeof raw === 'string' ? raw : error instanceof DOMException ? error.name : error instanceof Error ? error.message : '';
  switch (code) {
    case 'AUTH_REAUTH_WRONG_PASSWORD': return '비밀번호가 올바르지 않습니다. 다시 입력해 주세요.';
    case 'AUTH_REAUTH_TOO_MANY_REQUESTS': return '시도가 많습니다. 잠시 후 다시 시도해 주세요.';
    case 'AUTH_REAUTH_NETWORK_FAILED': return '네트워크 연결을 확인하고 다시 시도해 주세요.';
    case 'AUTH_REAUTH_SESSION_REQUIRED':
    case 'AUTH_REAUTH_IDENTITY_CHANGED': return '계정이 변경되었습니다. 로그아웃 후 다시 로그인해 주세요.';
    case 'PASSKEY_IDENTITY_CHANGED': return '계정이 변경되었습니다. 로그아웃 후 다시 로그인해 주세요.';
    case 'PASSKEY_NOT_REGISTERED': return '등록된 기기 인증이 없습니다. 비밀번호로 계속하거나 기기 인증을 등록해 주세요.';
    case 'PASSKEY_RECENT_PASSWORD_AUTH_REQUIRED': return '기기 인증을 등록하려면 비밀번호를 다시 확인해 주세요.';
    case 'PASSKEY_AUTHENTICATION_INVALID':
    case 'PASSKEY_REGISTRATION_INVALID': return '기기 인증을 확인하지 못했습니다. 다시 시도하거나 비밀번호를 사용해 주세요.';
    case 'PASSKEY_CHALLENGE_EXPIRED':
    case 'PASSKEY_CHALLENGE_REPLAYED': return '기기 인증 시간이 만료되었습니다. 다시 시도해 주세요.';
    case 'NotAllowedError': return '기기 인증이 취소되었거나 시간이 초과되었습니다.';
    default: return '잠금을 해제하지 못했습니다. 다시 시도하거나 로그아웃 후 로그인해 주세요.';
  }
}
